import React from "react";
import Image from "components/image";
import ButtonLink from "components/button-link";
import RichText from "components/rich-text";
import clsx from "clsx/lite";

const ImageGrid = ({ data }) => {
	const { title, items, cta, showOneItem } = data;

	return (
		<div>
			{title && <h2 className="font-base bg-black text-white px-4 text-h4 md:text-5xl text-center py-6 mb-10">
				{title.replace("Haylen Lights", "")}
				{title.includes("Haylen Lights") && <span className="text-beige"> Haylen Lights</span>}</h2>}
			<div className={clsx("standard-section-width mx-auto grid horizontal-padding grid-cols-1 gap-6 pb-10", 
				!showOneItem && "md:grid-cols-2 ")}>
				{items?.map((item, index) => (
					<div key={index} 
						className={clsx("px-4 py-6 md:p-6 border bg-white", showOneItem && "md:grid md:grid-cols-2 md:!p-8 md:gap-10")}>
						<div className={clsx("flex flex-col justify-center", item.imageLeft && "order-1")}>
							{item.title && <h3 className="text-lg lg:text-h4 xl:text-h1-xs/10 font-base">{item.title}</h3>}
							{item.description && (
								<div className="py-4 text-sm md:leading-5 md:text-base">
									<RichText data={{ content: item.description }} />
								</div>
							)}
						</div>
						{item.image && (
							<Image image={item.image}/>
						)}
					</div>
				))}
			</div>
			{cta && (
				<div className="w-full h-fit flex pb-10 justify-center">
					<ButtonLink data={cta} className="flex justify-center w-fit" />
				</div>
			)}
		</div>
	);
};

export default ImageGrid;